import { useState } from 'react';
import { decideAgentApproval } from '../../../../services/api/todoApi';

export default function useAgentApprovalDecision({companyId,item,onResolved}) {
    const [busy,setBusy]=useState(null),[error,setError]=useState(null);
    const decide=async decision=>{
        setBusy(decision);setError(null);
        const plan=item.resolvedPlan;
        const binding=plan?.contract==='bank-reconciliation/1'?{
            company_id:companyId,approval_id:item.approvalId,action_id:plan.action_id,
            plan_hash:plan.plan_hash,bank_generation:plan.bank.generation
        }:undefined;
        try {await decideAgentApproval(companyId,item.approvalId,decision,binding);onResolved();}
        catch(e){setError(e.response?.data?.error||'Kunde inte genomföras — försök igen');if(e.response?.status===409)onResolved();}
        finally{setBusy(null);}
    };
    return {busy,error,decide};
}
